import React, {Component} from 'react';
//constatns
import { FORM_REFS } from '../../../../constants';
//children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';

class GlsNotionalPoolingBasicDetails extends Component{
  constructor(props){
    super(props);
    this.state = {
      dataReady : false
    }
  }

  getBasicDetails = (basicDetails) =>{
    this.props.getBasicDetails(basicDetails);
  }

  saveRefresh = (event, apiUrl) => {
    this.props.saveRefreshClick(event, apiUrl)
  }

  render(){
    let formData;
    let mode;
    if(this.props.notionalPoolingdata !== undefined){
        formData = this.props.notionalPoolingdata;
        mode="edit";
    }else {
        formData ={};
        mode='';
    }
    const properties = {
        formData,
        editType: 'gls-notional-po',
        pathname: this.props.location.pathname
    };

    if (this.props.dataReady && this.props.formJson !== undefined && this.props.formJson.par !== undefined && this.props.formJson.par.aemform_basicDetails !== undefined) {
      var aemform = this.props.formJson.par.aemform_basicDetails;
      var formRef = this.props.formJson.par.aemform_basicDetails.formRef;
      var pageTitle = this.props.formJson.page_title_mainTitle;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <Dynamicform
            mode={mode}
            properties={properties}
            hideButtons={true}
            saveButton={true}
            onFormSubmit={this.saveRefresh}
            pageTitle={pageTitle}
            getFormData={this.getBasicDetails}
            url={url}
            lang={this.props.lang.currentLang.lang}
            flag={this.props.lang.currentLangFlag.flag}
            translatedData={this.props.lang.translatedData}
            resetDisable = {true}
          />
        );
      }
    }
    return(<div>Somthing went wrong</div>)
  }

}
export default GlsNotionalPoolingBasicDetails;



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/GlsNotionalPoolingBasicDetails.js